import React from 'react';
import { Close16 } from '@honeybook/icons';
import HBIconButton from '../HBIconButton/HBIconButton';
import { IntractableBasicTestIdProps } from '../common/internal/test-id.types';
import { useHBSidePanel } from './HBSidePanelProvider';

const HBSidePanelCloseButton: React.FC<IntractableBasicTestIdProps> = ({
    testId,
    testIdName = 'close'
}) => {
    const { closeSidePanel } = useHBSidePanel();

    return (
        <HBIconButton
            buttonTheme="subtle-invisible"
            icon={Close16}
            label="close"
            onClick={closeSidePanel}
            size="xs"
            testId={testId}
            testIdName={testIdName}
        />
    );
};

export default HBSidePanelCloseButton;
